import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { CsvUploadType } from '../../../../../../types/csvUploadConfiguration';
import CsvUploadConfigurationsScreen from '../../../../../components/CsvUploadConfiguration/CsvUploadConfigurationsScreen';
import CsvUploadConfigurationUpdatePane from '../../../../../components/CsvUploadConfiguration/CsvUploadConfigurationUpdatePane';
import { Routing } from '../../../../../../util/routes.util';
import {
  Breadcrumbs,
  StockLocationAdvancedSettingsCrumb,
  StockLocationSettingsCrumb,
} from '../../../../../components/Breadcrumbs';

export default function StockLocationAdvancedSettingsPane() {
  const navigate = useNavigate();

  return (
    <div className='flex h-full flex-grow flex-col'>
      <Breadcrumbs>
        <StockLocationSettingsCrumb />
        <StockLocationAdvancedSettingsCrumb current />
      </Breadcrumbs>
      <div className='content-y-breadcrumbs flex-grow flex-col'>
        <Routes>
          <Route
            path={'import_configurations/*'}
            element={
              <CsvUploadConfigurationsScreen
                type={CsvUploadType.stockLocation}
                backPath={Routing.settings.stockLocations.overview()}
              />
            }
          />
          <Route
            path={'import_configurations/update/:id/*'}
            element={
              <CsvUploadConfigurationUpdatePane
                type={CsvUploadType.stockLocation}
                onDone={() => navigate('import_configurations')}
              />
            }
          />
        </Routes>
      </div>
    </div>
  );
}
